import { enumSCArrowVariants } from "../constants";
import { Globals } from "../CoreApp/Globals";
import { ScaleSCArrowForTouch } from "./ScaleSCArrowForTouch";

export function GetSCArrowWidth(variant, pub) {
  var width;
  if (variant == null) variant = Globals._scArrowStyle;
  if (variant == enumSCArrowVariants.miniarrow || variant == enumSCArrowVariants.themearrow)
    width = 12;
  else width = 16;

  width = ScaleSCArrowForTouch(width, pub);

  return width;
}
